import { render, staticRenderFns } from "./allienceActive.vue?vue&type=template&id=31bad62e&scoped=true"
import script from "./allienceActive.vue?vue&type=script&lang=js"
export * from "./allienceActive.vue?vue&type=script&lang=js"
import style0 from "./allienceActive.vue?vue&type=style&index=0&id=31bad62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bad62e",
  null
  
)

export default component.exports